import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Layout from "../components/Layout";
import VenueCard from "../components/VenueCard";
import { api } from "../lib/api";
import { SkeletonGrid } from "../components/Skeleton";
import { Sparkles } from "lucide-react";

/**
 * Free things to do in and around Airlie Beach — lookouts, beaches, walks,
 * markets, parks. Shows every venue with `is_free=true` regardless of category.
 * Distinct from /tours (paid bookable experiences).
 */
export default function Activities() {
  const [venues, setVenues] = useState(null);
  useEffect(() => {
    api.get("/venues?is_free=true&limit=200").then((r) => setVenues(r.data));
  }, []);

  return (
    <Layout>
      <section className="max-w-7xl mx-auto px-6 pt-16 pb-24">
        <div className="mb-10 max-w-2xl">
          <span className="inline-flex items-center gap-2 text-sm tracking-widest text-coastal uppercase">
            <Sparkles className="w-4 h-4 text-sponsored" /> Free & easy
          </span>
          <h1 className="font-heading text-4xl lg:text-5xl text-navy tracking-tight mt-2" data-testid="activities-title">
            Free things to do in &amp; around Airlie
          </h1>
          <p className="mt-4 text-neutral-600 leading-relaxed">
            Coastal walks, lookouts, beaches, markets and parks — all the moments the
            Whitsundays gives away for free.
          </p>
        </div>

        {venues === null ? (
          <SkeletonGrid count={6} />
        ) : venues.length === 0 ? (
          <div className="text-center py-20 text-neutral-500" data-testid="activities-empty">
            No free activities listed yet. Check back soon — we&apos;re adding lookouts and walks weekly.
          </div>
        ) : (
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="grid md:grid-cols-2 lg:grid-cols-3 gap-6"
            data-testid="activities-grid"
          >
            {venues.map((v, i) => <VenueCard key={v.id} venue={v} index={i} />)}
          </motion.div>
        )}
      </section>
    </Layout>
  );
}
